import React, {useEffect, useMemo, useState} from "react";
import api from "../api";
import Select from "react-select";
import Needs from "./Needs";
import NeedSliderRange from "./NeedSliderRange";
import NeedSlider from "./NeedSlider";
import {Controller} from "react-hook-form";
import Popup from "./Popup";

const StepOneForm = (props) => {
    const [wishedDates, setWishedDates] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    const togglePopup = (message) => {
        setPopupMessage(message)
        setIsPopupOpen(!isPopupOpen);
    };

    useEffect(() => {
        const loadDates = async () => {
            try {
                const dates = await generateWhishedAccessionDates();
                setWishedDates(dates);
            } catch (error) {
                console.error("Erreur lors de la récupération des dates :", error);
            }
        };

        loadDates();
    }, []);

    useEffect(() => {
        const num1 = parseInt(props.employeeNumber);
        const num2 = parseInt(props.executiveNumber);
        if ((!isNaN(num1) && !isNaN(num2)) && num1 >= num2) {
            props.setNotExecutiveNumber(num1 - num2);
        } else {
            props.setNotExecutiveNumber('');
        }
    }, [props.employeeNumber, props.executiveNumber]);

    const handleKeyPress = (e) => {
        // Bloque la saisie si la touche n'est pas un chiffre (0-9)
        if (!/^[0-9]$/.test(e.key)) {
            e.preventDefault();
        }
    };

    const handleInputChange = (value) => {
        {
            const fetchApeCodes = async () => {
                const apeCodes = await api.getApeCodes(value);
                props.setApeCodes(apeCodes.map((item) => ({
                    value: `${item.id}_${item.code}_${item.label}`,
                    label: item.code
                })));
            };
            const fetchConventions = async () => {
                const conventions = await api.getConventions(value);
                props.setConventions(conventions)
            };

            if (value.trim() === "") {
                props.setApeCodes([]);
            } else {
                fetchApeCodes();
                if (value.length === 5) {
                    fetchConventions();
                }
            }

            props.setApeCode(value);
        }
    }

    const handleChange = (option) => {
        handleInputChange(option.label);
        props.setValue('inputApeCode', option.label); //Utile pour la validation du formulaire
        props.setSelectedApeOption(option);
    }

    const handlePostalCodeChange = (e) => {
        const fetchCities = async () => {
            const cities = await api.getCities(e.target.value);
            props.setValue('inputCity', `${cities?.[0].id},${cities?.[0].name}`);
            props.setCities(cities);
        };

        if (e.target.value.trim() === "") {
            props.setCities([]); // Réinitialise les options si l'input est vide
        } else if (e.target.value.length === 5) {
            fetchCities();
        }
        props.setPostalCode(e.target.value);
    }

    return (
        <>
            {isPopupOpen && <Popup message={popupMessage} onClose={togglePopup}/>}
            <span className="tw-self-stretch tw-text-mutelios-blue tw-text-sm-h2 lg:tw-text-h2">Détermination des besoins</span>
            {props.mode === 2 && (
                <div className="tw-flex tw-flex-col tw-gap-3">
                    <span className="tw-text-body-lead-bold">Paramètres ajustables</span>
                    <Needs/>
                </div>
            )}

            {props.mode === 1 ? <> <NeedSlider
                    title="Soins courants"
                    value={props.routineCareValue}
                    setValue={props.setRoutineCareValue}
                    handleNeedsChange={props.handleNeedsChange}
                    max={5}
                    railColor="#DAE8F1"
                />
                    <NeedSlider
                        title="Hospitalisation"
                        value={props.hospitalizationValue}
                        setValue={props.setHospitalizationValue}
                        handleNeedsChange={props.handleNeedsChange}
                        max={5}
                        railColor="#DAE8F1"
                    />
                    <NeedSlider
                        title="Dentaire"
                        value={props.dentaryValue}
                        setValue={props.setDentaryValue}
                        handleNeedsChange={props.handleNeedsChange}
                        max={6}
                        railColor="#DAE8F1"
                    />
                    <NeedSlider
                        title="Optique"
                        value={props.opticalValue}
                        setValue={props.setOpticalValue}
                        handleNeedsChange={props.handleNeedsChange}
                        max={6}
                        railColor="#DAE8F1"
                    /></>
                :
                <>
                    <NeedSliderRange
                        title="Soins courants"
                        range={props.routineCareRange}
                        setRange={props.setRoutineCareRange}
                        handleNeedsChange={props.handleRangeNeedsChange}
                        railColor="#DAE8F1"
                    />
                    <NeedSliderRange
                        title="Hospitalisation"
                        range={props.hospitalizationRange}
                        setRange={props.setHospitalizationRange}
                        handleNeedsChange={props.handleRangeNeedsChange}
                        railColor="#DAE8F1"
                    />
                    <NeedSliderRange
                        title="Dentaire"
                        range={props.dentaryRange}
                        setRange={props.setDentaryRange}
                        handleNeedsChange={props.handleRangeNeedsChange}
                        railColor="#DAE8F1"
                    />
                    <NeedSliderRange
                        title="Optique"
                        range={props.opticalRange}
                        setRange={props.setOpticalRange}
                        handleNeedsChange={props.handleRangeNeedsChange}
                        railColor="#DAE8F1"
                    /></>
            }

            <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-6 tw-self-stretch">
                <div className="tw-flex tw-flex-col tw-gap-6 tw-self-stretch">
                    <span className="tw-self-stretch tw-text-mutelios-blue tw-text-sm-h2 lg:tw-text-h2">Formulaire de renseignement</span>
                    <div
                        className={`tw-flex tw-flex-col tw-gap-2 tw-self-stretch tw-justify-center tw-items-center ${props.errors.inputDevisType && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}>
                <span
                    className="tw-self-stretch tw-text-sm-h4 md:tw-text-body-lead-bold">Type de devis souhaité *</span>
                        <div className="tw-flex tw-gap-2 tw-self-stretch tw-items-center">
                            <input {...props.register("inputDevisType", {required: true})}
                                   id="wishedCover1" value="EMP"
                                   onChange={(e) => props.setDevisType(e.target.value)}
                                   name="inputDevisType" type="radio"/>
                            <label htmlFor="wishedCover1" className="md:tw-text-body tw-text-sm-body tw-grow">Couverture
                                obligatoire de vos
                                Salariés et facultative de leurs ayants droit</label>
                            <img onClick={() => togglePopup(1)} src="/o/mutelios-theme-css/icons/QuestionBlack.svg"
                                 alt=""/>
                        </div>
                        <div className="tw-flex tw-gap-2 tw-self-stretch tw-items-center">
                            <input {...props.register("inputDevisType", {required: true})}
                                   id="wishedCover2"
                                   onChange={(e) => props.setDevisType(e.target.value)}
                                   value="EMP_FAM" type="radio"/>
                            <label htmlFor="wishedCover2" className="md:tw-text-body tw-text-sm-body tw-grow">Couverture
                                obligatoire de vos
                                Salariés et de leurs ayants droit</label>
                            <img onClick={() => togglePopup(2)} src="/o/mutelios-theme-css/icons/QuestionBlack.svg"
                                 alt=""/>
                        </div>
                    </div>
                    <div className="tw-flex tw-flex-col tw-gap-6 tw-self-stretch tw-justify-center">
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <label htmlFor="inputEmployeeNumber" className="tw-text-sm-h5 lg:tw-text-h5">Nombre de
                                salariés *</label>
                            <input {...props.register("inputEmployeeNumber", {required: true})} id="inputEmployeeNumber"
                                   type="text" onKeyPress={handleKeyPress} maxLength="10"
                                   value={props.employeeNumber}
                                   onChange={(e) => props.setEmployeeNumber(e.target.value)}
                                   className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputEmployeeNumber && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <label htmlFor="inputExecutiveNumber" className="tw-text-sm-h5 lg:tw-text-h5">Nombre de
                                cadres *</label>
                            <input {...props.register("inputExecutiveNumber", {required: true})}
                                   id="inputExecutiveNumber" type="text" value={props.executiveNumber}
                                   type="text" onKeyPress={handleKeyPress} maxLength="10"
                                   onChange={(e) => props.setExecutiveNumber(e.target.value)}
                                   className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputExecutiveNumber && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <label className="tw-text-sm-h5 lg:tw-text-h5">Nombre de
                                non cadres</label>
                            <input type="text" value={props.notExecutiveNumber} disabled
                                   className="tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border"/>
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <label htmlFor="inputExecutiveAverageAge, {required: true}"
                                   className="tw-text-sm-h5 lg:tw-text-h5">Age moyen
                                des cadres *</label>
                            <div className="tw-flex tw-flex-col tw-gap-1">
                                <input {...props.register("inputExecutiveAverageAge", {required: true})}
                                       id="inputExecutiveAverageAge"
                                       type="text" onKeyPress={handleKeyPress} maxLength="3"
                                       className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputExecutiveAverageAge && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                                <span className="tw-text-body-small">L'âge moyen des cadres doit être supérieur à l'âge moyen des non-cadre</span>
                            </div>
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <label htmlFor="inputNonExecutiveAverageAge" className="tw-text-sm-h5 lg:tw-text-h5">Age
                                moyen
                                des non cadres *</label>
                            <input {...props.register("inputNonExecutiveAverageAge", {required: true})}
                                   id="inputNonExecutiveAverageAge" type="text" onKeyPress={handleKeyPress}
                                   maxLength="3"
                                   className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputNonExecutiveAverageAge && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <label htmlFor="inputPostalCode" className="tw-text-sm-h5 lg:tw-text-h5">Code postal et
                                commune *</label>
                            <div
                                className="tw-flex tw-gap-6 tw-items-start tw-content-start tw-self-stretch tw-flex-wrap">
                                <input {...props.register("inputPostalCode", {required: true})} value={props.postalCode}
                                       onChange={handlePostalCodeChange} id="inputPostalCode"
                                       type="text" onKeyPress={handleKeyPress} maxLength="5" placeholder="Code postal"
                                       className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.inputPostalCode && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}/>
                                <Controller
                                    name="inputCity"
                                    control={props.control}
                                    render={({field}) => (
                                        <select {...field}
                                                className="tw-flex tw-flex-1 tw-min-w-[312px] tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border">
                                            {props.cities.length > 0 ? (
                                                props.cities.map((option) => (
                                                    <option key={option.id} value={`${option.id},${option.name}`}>
                                                        {option.name}
                                                    </option>
                                                ))
                                            ) : (
                                                <></>
                                            )}
                                        </select>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <label htmlFor="react-select-3-input" className="tw-text-sm-h5 lg:tw-text-h5">Code APE
                                *</label>
                            <Controller
                                name="inputApeCode"
                                control={props.control}
                                rules={{required: true}}
                                render={({field}) => (
                                    <Select
                                        {...field}
                                        options={props.apeCodes}
                                        onInputChange={handleInputChange}
                                        onChange={handleChange}
                                        value={props.selectedApeOption}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                borderColor: state.isFocused ? 'black' : '#96ACBA',
                                                padding: '7px 0px',
                                            }),
                                        }}
                                        noOptionsMessage={() => "Aucun code APE correspondant"}
                                        placeholder="Entrez un cope APE"
                                    />
                                )}
                            />
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <label className="tw-text-sm-h5 lg:tw-text-h5">Convention
                                collective</label>
                            <select id="inputConvention" {...props.register("inputConvention")}
                                    className="tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border">
                                {props.conventions.length > 0 ? (
                                    props.conventions.map((option) => (
                                        <option key={option.id} value={`${option.id}_${option.code}_${option.label}`}>
                                            {option.label}
                                        </option>
                                    ))
                                ) : (
                                    <></>
                                )}
                            </select>
                        </div>
                        <div className="tw-flex tw-flex-col tw-gap-2">
                            <label className="tw-text-sm-h4 lg:tw-text-h4">Avez-vous un contrat complémentaire santé
                                obligatoire ?</label>
                            <div className="tw-self-stretch">
                                <div className="tw-flex tw-items-start tw-gap-2">
                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        <input {...props.register("healthAdditionalContract")} value="yes"
                                               id="healthAdditionalContractYes"
                                               type="radio"/>
                                        <label htmlFor="healthAdditionalContractYes">Oui</label>
                                    </div>
                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        <input {...props.register("healthAdditionalContract")} value="no"
                                               id="healthAdditionalContractNo"
                                               type="radio" defaultChecked/>
                                        <label htmlFor="healthAdditionalContractNo">Non</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="tw-flex tw-flex-col md:tw-flex-row tw-items-start tw-content-center tw-gap-6 tw-self-stretch ">
                            <div
                                className="tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-2 tw-self-stretch tw-flex-1">
                                <span
                                    className="tw-text-sm-h4 lg:tw-text-body-lead-bold">Date d'adhésion souhaitée *</span>
                                <select {...props.register("whishedAccessionDate", {required: true})}
                                        id="whishedAccessionDate"
                                        className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.whishedAccessionDate && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}>
                                    <option></option>
                                    {wishedDates.length > 0 ? (
                                        wishedDates.map((option) => (
                                            <option key={option.key} id={option.key}>
                                                {option.label}
                                            </option>
                                        ))
                                    ) : (
                                        <></>
                                    )}
                                </select>
                            </div>
                            <div
                                className="tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-2 tw-self-stretch tw-flex-1">
                                <span className="tw-text-sm-h4 lg:tw-text-body-lead-bold">Régime d’affiliation *</span>
                                <select {...props.register("affiliationScheme", {required: true})}
                                        id="affiliationScheme"
                                        className={`tw-flex tw-py-3 tw-px-2 tw-gap-2 tw-self-stretch tw-items-center tw-rounded tw-border-solid tw-border tw-border-mutelios-blue-border ${props.errors.affiliationScheme && ("tw-border-solid tw-border-2 tw-border-mutelios-danger")}`}>
                                    <option></option>
                                    <option value="1,REGIME_GENERAL">Régime général</option>
                                    <option value="3,REGIME_ALSACE_MOSELLE">Régime local Alsace Moselle</option>
                                    <option value="4,REGIME_AGRICOLE">Régime agricole</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
        ;
}

const generateWhishedAccessionDates = async () => {
    const dates = [];
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    // 1. On récupère l'année limite depuis l'API
    const limitYear = await api.getYearDevis();

    let start = 1;
    let max = 12;

    for (start; start <= max; start++) {
        const year = currentYear + Math.floor((currentMonth + start) / 12);
        const month = (currentMonth + start) % 12;

        // 2. Condition de blocage : si l'année calculée dépasse l'année limite, on arrête
        if (year > limitYear) {
            break;
        }

        const firstDay = new Date(year, month, 1);

        dates.push({
            key: formatDate(firstDay),
            label: formatDate(firstDay) + (start === max ? " ou ultérieurement" : "")
        });
    }
    return dates;
};

const formatDate = (date) => {
    return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
};

export default StepOneForm;